import React from 'react';

import { BasketContent, UniverseReference, User, WellnessBasketPrices } from '@front/common/src/types/commons';
import { getBasketMode } from '@front/common/src/ducks/customer/basket';
import { getBasketPrices } from '@front/common/src/ducks/customer/basket-selectors';
import { useConfig } from '@front/common/src/providers/config-provider';

import { WithClassNameProps } from '@front/web-ui/src/components/types';

import { MembershipCardContainer, MembershipCardSwitch as StyledSwitch } from '../../membership-card/common';
import { trackMembershipEvent } from '../../../../utils/tracking';
import { useAppSelector } from '../../../../store';

import MembershipCardContent from './membership-card-content/membership-card-content';

type MembershipSwitchProps = WithClassNameProps & {
  isMembershipRequested: boolean;
  setIsMembershipRequested: (isRequested: boolean) => void;
  openMembershipPaywall: () => void;
  pathname: string;
  user?: User;
  universeReference: UniverseReference;
  canSubscribeToMembership: boolean;
  basketContent: BasketContent;
};

const MembershipCard = ({
  isMembershipRequested,
  setIsMembershipRequested,
  openMembershipPaywall,
  pathname,
  user,
  universeReference,
  canSubscribeToMembership,
  basketContent,
  className,
}: MembershipSwitchProps) => {
  const config = useConfig();
  const mode = useAppSelector(getBasketMode);
  const prices = useAppSelector((state) => getBasketPrices(state, config)) as WellnessBasketPrices;

  const onChange = () => {
    const newSwitchValue = !isMembershipRequested;

    setIsMembershipRequested(newSwitchValue);
    trackMembershipEvent({
      eventType: 'MembershipSwitchClick',
      user,
      universeReference,
      mode,
      path: pathname,
      additionalData: {
        turningOn: newSwitchValue,
      },
    });
  };

  const onReadMorePress = () => {
    trackMembershipEvent({
      eventType: 'MoreDetailsMembershipClick',
      user,
      universeReference,
      mode,
      path: pathname,
    });

    openMembershipPaywall();
  };

  return (
    <MembershipCardContainer className={className}>
      <MembershipCardContent
        basketContent={basketContent}
        user={user}
        getMoreInfoPress={onReadMorePress}
        reduction={prices.membership.reduction}
      />
      {canSubscribeToMembership && (
        <label htmlFor='membership-switch'>
          <StyledSwitch
            id='membership-switch'
            name='membership-switch'
            onChange={onChange}
            isChecked={isMembershipRequested}
            value={String(isMembershipRequested)}
            variant='pink'
          />
        </label>
      )}
    </MembershipCardContainer>
  );
};

export default MembershipCard;
